<ng-container *transloco="let t">
  <div class="text-sm font-medium text-gray-500">
    @if (modalData.productGroups.length === 1) {
      <p>{{ t("product-group-deletion.deletion_confrimation", [modalData.productGroups[0].productGroupName]) }}</p>
    } @else {
      <p>{{ t("product-group-deletion.multiple_deletion_confirmation", [modalData.productGroups.length]) }}</p>
    }
  </div>
  <div class="flex justify-end gap-x-2 pt-4">
    <button iButton variant="secondary" (click)="modalRef.close()">{{ t("common.cancel") }}</button>
    <button iButton variant="destructive" (click)="delete()" [loading]="loading()">{{ t("common.delete") }}</button>
  </div>
</ng-container>
